import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Link,
  Box,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { makeStyles } from "@mui/styles";

const useCommonStyles = makeStyles((theme) => ({
  card: {
    height: 200,
    backgroundColor: "transparent !important",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: theme.spacing(1),
    },
  },
  // Adjust header padding and alignment
  cardHeader: {
    paddingTop: `${theme.spacing(0)} !important`,
    paddingBottom: `${theme.spacing(1)} !important`,
    textAlign: "left",
    paddingLeft: `${theme.spacing(4)} !important`,
  },
  // Adjust content padding and alignment
  cardContent: {
    paddingTop: `${theme.spacing(0)} !important`,
    textAlign: "left",
    paddingLeft: `${theme.spacing(4)} !important`,
    // background:"yellow"
  },
  content: {
    fontSize: "0.9rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    },
  },
  link: {
    color: "#000 !important", 
    textDecoration: "none",
    marginBottom: theme.spacing(0.5),
    fontSize: "0.9rem",
    "&:hover": {
      textDecoration: "underline",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    },
  },
  linkContainer: {
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(1),
    alignItems: "flex-start",
  },
  officeText: {
    fontSize: "0.9rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    },
  },
  contactText: {
    fontSize: "0.9rem",
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    },
  },
  socialContainer: {
    display: "flex",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    justifyContent: "flex-start",
    "& a": {
      color: "#000",
      fontSize: "24px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
      },
    },
  },
}));


// -----------------------------
// MiniAboutUs Component
// -----------------------------
export const MiniAboutUs = () => {
  const classes = useCommonStyles();

  return (
    <Card elevation={0} square  className={classes.card}>
      <CardHeader
        title="RaSynth"
        titleTypographyProps={{ variant: "h6" }}
        classes={{ root: classes.cardHeader }}
      />
      <CardContent className={classes.cardContent}>
        <Typography className={classes.content}>
          RaSynth is a leading provider of innovative solutions. We are
          committed to delivering high-quality products and services to our
          customers.
        </Typography>
      </CardContent>
    </Card>
  );
};

// -----------------------------
// MiniNavbar Component
// -----------------------------
export const MiniNavbar = () => {
  const classes = useCommonStyles();

  return (
    <Card elevation={0} square className={classes.card}>
      <CardHeader
        title="Company"
        titleTypographyProps={{ variant: "h6" }}
        classes={{ root: classes.cardHeader }}
      />
      <CardContent className={classes.cardContent}>
        <Box className={classes.linkContainer}>
          <Link underline="none" href="/about-us" className={classes.link}>
            About Us
          </Link>
          <Link underline="none" href="/service" className={classes.link}>
            Service
          </Link>
          <Link underline="none" href="/blog" className={classes.link}>
            Blog
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};

// -----------------------------
// MiniOffice Component
// -----------------------------
export const MiniOffice = () => {
  const classes = useCommonStyles();

  return (
    <Card elevation={0} square className={classes.card}>
      <CardHeader
        title="Office"
        titleTypographyProps={{ variant: "h6" }}
        classes={{ root: classes.cardHeader }}
      />
      <CardContent className={classes.cardContent}>
        <Typography className={classes.officeText}>
          Bangalore, India
        </Typography>
      </CardContent>
    </Card>
  );
};

// -----------------------------
// MiniContactUs Component
// -----------------------------
export const MiniContactUs = () => {
  const classes = useCommonStyles();

  return (
    <Card elevation={0} square className={classes.card}>
      <CardHeader
        title="Contact"
        titleTypographyProps={{ variant: "h6" }}
        classes={{ root: classes.cardHeader }}
      />
      <CardContent className={classes.cardContent}>
        <Typography className={classes.contactText}>
          Email: tech@rasynth.com
        </Typography>
        <Typography className={classes.contactText}>
          Phone: +91 6235411488
        </Typography>
        <Box className={classes.socialContainer}>
          <Link href="https://www.linkedin.com" aria-label="LinkedIn">
            <LinkedInIcon />
          </Link>
          <Link href="https://www.facebook.com" aria-label="Facebook">
            <FacebookIcon />
          </Link>
          <Link href="https://www.instagram.com" aria-label="Instagram">
            <InstagramIcon />
          </Link>
          <Link href="https://www.twitter.com" aria-label="Twitter">
            <TwitterIcon />
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};
